import { LayoutDashboard, Sparkles, ClipboardList, MessagesSquare, Inbox, FileText, Globe, Scale, HardHat, CalendarCheck, Activity, Phone, Settings, Bell } from "lucide-react";

// Hand-built product MOCKUP for the PlatformTools section — a synthetic recreation of the
// manager workspace (same shell, nav and overview), NOT a real screenshot. On-brand red
// accent, faded at the bottom like a marketing image.
const NAV = [
  { items: [{ icon: Activity, label: "Pulse", count: "1" }] },
  { items: [{ icon: LayoutDashboard, label: "Overview", active: true }, { icon: Sparkles, label: "Ask Copilot" }] },
  { label: "INBOX", items: [{ icon: ClipboardList, label: "Requests" }, { icon: MessagesSquare, label: "Conversations" }, { icon: Inbox, label: "Mail", tag: "copilot", count: "45" }] },
  { label: "KNOWLEDGE", items: [{ icon: FileText, label: "AI Documents" }, { icon: Globe, label: "Website Knowledge" }, { icon: Scale, label: "Rules" }] },
  { label: "OPERATIONS", items: [{ icon: HardHat, label: "Field Services" }, { icon: CalendarCheck, label: "Reservations" }] },
];
const SIGNALS = [
  { tone: "red", title: "Requests still open after 2 weeks", sub: "Follow-through · 25 points off" },
  { tone: "red", title: "Complaints left hanging", sub: "92% · 25 points off" },
  { tone: "green", title: "Conversations within a healthy range", sub: "3.1% · handled" },
];
const TILES = [
  ["PENDING APPROVALS", "0", "Review the roster"],
  ["UNKNOWN CONTACTS · 7D", "12", "Open conversations"],
  ["NEW SELF-REGS · 7D", "0", "From call & text"],
  ["SMS OPT-INS · 7D", "21", "View consent"],
];

export const PlatformSurfaceArt = () => (
  <figure className="rm-mock" data-testid="concept-platform-surface" aria-label="Illustrative mockup of the Ask Redline manager workspace — sidebar of tools with a community overview and Community Pulse.">
    <div className="rm-mock-frame">
      <div className="rm-mock-bar" aria-hidden="true">
        <span className="rm-mock-dots"><i /><i /><i /></span>
        <span className="rm-mock-url">app.askredline.com/dashboard</span>
      </div>
      <div className="rm-ui" aria-hidden="true">
        <aside className="rm-ui-side">
          <div className="rm-ui-brand"><span className="rm-ui-brand-mk">M</span><span><b>Maplewood HOA</b><small>COMMUNITY · ASK REDLINE</small></span></div>
          {NAV.map((g, gi) => (
            <div className="rm-ui-group" key={gi}>
              {g.label && <div className="rm-ui-glabel">{g.label}</div>}
              {g.items.map((it) => (
                <div className={`rm-ui-item${it.active ? " active" : ""}`} key={it.label}>
                  <it.icon strokeWidth={1.6} /><span className="rm-ui-sp">{it.label}</span>
                  {it.tag && <span className="rm-ui-tag">{it.tag}</span>}
                  {it.count && <span className="rm-ui-count">{it.count}</span>}
                </div>
              ))}
            </div>
          ))}
        </aside>
        <div className="rm-ui-main">
          <div className="rm-ui-top">
            <span className="rm-ui-top-name">MAPLEWOOD COMMUNITY HOA</span>
            <div className="rm-ui-top-actions">
              <span className="rm-ui-pill"><Phone size={10} /> +1 320 338 7878</span>
              <span className="rm-ui-ic"><Settings size={12} /></span>
              <span className="rm-ui-ic"><Bell size={12} /><span className="rm-ui-dot">50</span></span>
            </div>
          </div>
          <div className="rm-ui-body">
            <div className="rm-ui-kicker">COMMUNITY OVERVIEW</div>
            <div className="rm-ui-h">Maplewood Community HOA</div>
            <div className="rm-ui-sub">How your assistant is helping residents · last 30 days</div>
            <div className="rm-ui-pulse">
              <div className="rm-ui-pulse-top">
                <span className="rm-ui-pulse-dot" /><span className="rm-ui-pulse-title">Pulse</span>
                <span className="rm-ui-badge-red">RED · 50</span>
                <span className="rm-ui-pulse-meta">updated 5:37 AM</span>
              </div>
              {SIGNALS.map((s) => (
                <div className="rm-ui-sig" key={s.title}>
                  <span className={`rm-ui-sig-dot ${s.tone}`} />
                  <span className="rm-ui-sig-sp"><b>{s.title}</b><small>{s.sub}</small></span>
                  <span className="rm-ui-sig-btn">See them</span>
                </div>
              ))}
            </div>
            <div className="rm-ui-tiles">
              {TILES.map(([label, num, foot]) => (
                <div className="rm-ui-tile" key={label}><small>{label}</small><b>{num}</b><span>{foot}</span></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </figure>
);
